import { Component, Element, Event, EventEmitter, Fragment, Host, Prop, State, h } from '@stencil/core';
import { breakpoints } from '../../shared/breakpoints';
import { ProgressInfo } from '../dynamic-order-progression-stepper/dynamic-order-progression-stepper';

@Component({
  tag: 'order-progression-step',
  styleUrl: 'order-progression-step.scss',
  shadow: true,
})
export class OrderProgressionStep {
  @Element() hostElement: HTMLElement;
  @Event() downloadClicked: EventEmitter<void>;
  @Prop() progressInfo: ProgressInfo;
  @Prop() isLast: boolean;
  @State() isMobile: boolean;
  @State() isTablet: boolean;
  @State() isDesktop: boolean;

  private symbol: HTMLElement;
  private bar: HTMLElement;

  componentWillLoad() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  componentDidLoad() {
    this.setDomRefs();
    this.applyStyles();
  }

  componentDidUpdate() {
    this.setDomRefs();
    this.applyStyles();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkScreenSize.bind(this));
  }

  checkScreenSize() {
    const { mobile, tablet, desktop } = breakpoints;
    this.isMobile = window.matchMedia(`(min-width: ${mobile}px) and (max-width: ${tablet})`).matches;
    this.isTablet = window.matchMedia(`(min-width: ${tablet}px) and (max-width: ${desktop}px)`).matches;
    this.isDesktop = window.matchMedia(`(min-width: ${desktop}px)`).matches;
  }

  setDomRefs() {
    if (!this.isLast) {
      if (this.isDesktop || this.isTablet) {
        this.bar = this.hostElement.shadowRoot.querySelector('.header .bar');
      } else {
        this.bar = this.hostElement.shadowRoot.querySelector('.footer .bar');
      }
    }
    this.symbol = this.hostElement.shadowRoot.querySelector('.symbol');
  }

  applyStyles() {
    if (this.isLast && this.bar) {
      this.bar.style.display = 'none';
    } else if (this.bar) {
      this.bar.style.display = '';
    }
    this.symbol.className = 'symbol';
    switch (this.progressInfo.progress) {
      case 'Todo':
        this.symbol.classList.add('todo');
        break;
      case 'Current':
        const innerCircle = document.createElement('div');
        innerCircle.classList.add('inner-circle');
        this.symbol.appendChild(innerCircle);
        this.symbol.classList.add('current');
        break;
      case 'Done':
        this.symbol.classList.add('done');
        this.symbol.innerHTML = '<span class="material-icons-sharp check-sym">check</span>';
        break;
      case 'Cancelled':
        this.symbol.classList.add('cancelled');
        this.symbol.innerHTML = '<span class="material-icons-sharp close-sym">close</span>';
        break;
      case 'Error':
        this.symbol.classList.add('error');
        this.symbol.innerHTML = '<span class="material-icons-outlined error-sym">priority_high</span>';
        break;
    }
  }

  render() {
    return (
      <Host>
        {this.isDesktop || this.isTablet ? (
          <Fragment>
            <div class="header">
              <div class="symbol" />
              {this.isLast ? (
                <div class="footer download-button-desktop">
                  <slot name='button' />
                </div>
              ) : (
                <div class="bar" />)}
            </div>
            <div class="state">{this.progressInfo.step}</div>
            <div class="details">{this.progressInfo.details}</div>
          </Fragment>
        ) : (
          <Fragment>
            <div class="header">
              <div class="symbol" />
              <div class="body">
                <div class="state">{this.progressInfo.step}</div>
                <div class="details">{this.progressInfo.details}</div>
              </div>
            </div>
            {this.isLast ? (
              <div class="footer download-button-mobile">
                <slot name='button' />
              </div>
            ) :
              (
                <div class="footer">
                  <div class="bar" />
                </div>
              )}
          </Fragment>
        )}
      </Host>
    );
  }
}
